import { render } from "./Article-ads-banner.vue?vue&type=template&id=8ac4f08c"
import script from "./Article-ads-banner.vue?vue&type=script&lang=js"
export * from "./Article-ads-banner.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__